'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { FaXmark } from 'react-icons/fa6';
import { useAppDispatch } from '@/lib/redux/hooks';
import { deleteCartItem, fetchCartItems } from '@/lib/redux/features/cart';
import CartQuantity from './CartQuantity';
import NextImage from '@/features/Image';
import { FaRegTrashAlt } from 'react-icons/fa';
import { pushToDataLayer, toGa4CartItem } from '@/features/gtm/gtmUtils';

//

const CartItemCard = ({ product, total }: { product: any; total: number }) => {
  const dispatch = useAppDispatch();

  const removeProduct = () => {
    dispatch(deleteCartItem(product.id));
    pushToDataLayer('remove_from_cart', {
      ecommerce: {
        value: Number(product?.price) * Number(product?.quantity),
        currency: 'BDT',
        items: [
          toGa4CartItem(product),
        ],
      },
    });
    // pixelTrack('remove_from_cart', {
    //   member_id: user?.data?.id || null,
    //   item_id: product?.id,
    //   value: product?.price,
    //   currency: 'BDT',
    // });
  };

  // useEffect(() => {
  //   dispatch(fetchCartItems());
  // }, [dispatch]);

  return (
    <div className="cart d-flex align-items-center gap-3">
      {/* <FacebookPixelClient
        name="view_cart"
        data={{
          member_id: user?.data?.id || null,
          items: product,
          value: total,
          currency: 'BDT',
        }}
      /> */}
      {/* Product Image */}
      <div className="flex-shrink-0">
        <Link href="#">
          <NextImage
            width={80}
            height={80}
            src={product.product_thumbnail_image}
            alt={product?.title}
            className="img-fluid rounded"
          />
        </Link>
      </div>

      {/* Product Info */}
      <div className="flex-grow-1 w-100 product-info__wrapper">
        <div className="d-flex justify-content-between align-items-start">
          <h5 className="mb-0 product-title1">
            <Link href={`/product/${product?.slug}`}>
              {product.product_name}
            </Link>
          </h5>

          {/* Remove icon on mobile (will be shown last in mobile) */}
        </div>

        {/* For desktop view */}
        <div className="d-none d-md-block">
          <div className="d-flex justify-content-between align-items-lg-center gap-2 gap-md-5 flex-wrap">
            {/* Unit Price */}
            <div>
              <span className="fw-semibold text-muted">Price:</span>{' '}
              {product.currency_symbol}
              {Number(product.price).toFixed(2)}
            </div>

            {/* Quantity Control */}
            <div>
              <CartQuantity product={product} />
            </div>

            {/* Total Price (desktop only) */}
            <div className="d-none d-md-block">
              <span className="fw-semibold">Total:</span>{' '}
              {product.currency_symbol}
              {(Number(product.price) * product.quantity).toFixed(2)}
            </div>

            {/* Remove Button (desktop only) */}
            <div className="cart__delete d-none d-md-block order-md-4">
              <span onClick={removeProduct} style={{ cursor: 'pointer' }}>
                <FaXmark />
              </span>
            </div>
          </div>
        </div>

        {/* For mobile view */}
        <div className=" d-md-none w-100">
          <div className="d-flex justify-content-between align-items-center mt-2 gap-2 md-gap-5 flex-wrap">
            {/* Unit Price */}
            <div>
              <span className="fw-semibold text-muted">Price:</span>{' '}
              {product.currency_symbol}
              {Number(product.price).toFixed(2)}
            </div>

            {/* Quantity Control */}
            <div>
              <span
                onClick={removeProduct}
                className="text-danger"
                style={{ cursor: 'pointer' }}
              >
                <FaRegTrashAlt />
              </span>
            </div>

            {/* Total Price (desktop only) */}
            <div className="d-none d-md-block">
              <strong>Total:</strong> {product.currency_symbol}
              {(Number(product.price) * Number(product.quantity)).toFixed(2)}
            </div>

            {/* Remove Button (desktop only) */}
            <div className="d-none d-md-block order-md-4">
              <span
                onClick={removeProduct}
                className="text-danger"
                style={{ cursor: 'pointer' }}
              >
                <FaRegTrashAlt />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="d-md-none">
        <CartQuantity product={product} />
      </div>
    </div>
  );
};

export default CartItemCard;
